module.exports = __webpack_public_path__ + "img/enterprise-tenet.1aafd67c.jpg";